module.exports = __webpack_public_path__ + "img/8ac0a9d5296799dc3c870287a3867d7f.png";